var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"comp-wrap"},[_c('div',{ref:"box",staticClass:"box"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }